import { finish, error } from '../../../modules/events/actions/create';
import api from '../../../api';

export function request(dispatch, action) {
    $appState.sdkStaff.createEvent({requestBody: action})
        .then(data => dispatch(finish(data)))
        .catch(errors => dispatch(error(errors)));
    // api.post('/events', action).then(
    //     (data) => dispatch(finish(data)),
    //     ({ errors }) => dispatch(error(errors))
    // );
}
